import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { translator } from "@/lib/translator";

const PRIVATE_RE = /^\/(app|login|mot-de-passe-oublie|reset-password)/;

export default function AutoTranslator() {
  const location = useLocation();

  useEffect(() => {
    const isPublic = !PRIVATE_RE.test(location.pathname);
    const lang = translator.getStoredLang();
    if (isPublic && lang !== "fr") {
      const t = setTimeout(() => translator.apply(lang), 300);
      return () => clearTimeout(t);
    }
    translator.restore();
  }, [location.pathname]);

  return null;
}
